import React from "react";
import SectionHeading from "../../components/SectionHeading";
import ServiceArea from "./ServiceArea";
import { serviceAreas, serviceAreasTitle } from "./servicesContent";

/**
 * The seven service areas. Each area occupies its own full-width band with an
 * alternating surface, so areas with very different amounts of detail sit
 * comfortably next to each other instead of being forced into equal-height
 * grid cells.
 */
const ServiceAreas = () => (
  <section aria-labelledby="services-areas-heading">
    <div className="bg-white pt-14 lg:pt-20">
      <div className="sectionlayout">
        <SectionHeading
          id="services-areas-heading"
          title={serviceAreasTitle}
          className="mb-0"
        />
      </div>
    </div>
    {serviceAreas.map((area, index) => (
      <div
        key={area.id}
        className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
      >
        <ServiceArea area={area} />
      </div>
    ))}
  </section>
);

export default ServiceAreas;
